import React, { useMemo } from 'react';

/**
 * Representación visual del código QR impreso en la etiqueta del expediente.
 * El patrón es determinista a partir del localizador.
 */
export function CodigoQR({
  valor,
  tamano = 96
}: {
  valor: string;
  tamano?: number;
}) {
  const modulos = 21;
  const celdas = useMemo(() => {
    let semilla = 0;
    for (let i = 0; i < valor.length; i++) semilla = (semilla * 31 + valor.charCodeAt(i)) % 100003;
    const resultado: boolean[] = [];
    for (let i = 0; i < modulos * modulos; i++) {
      semilla = (semilla * 1103515245 + 12345) % 2147483648;
      resultado.push((semilla >> 16) % 100 < 47);
    }
    return resultado;
  }, [valor]);
  const esOjo = (fila: number, col: number) => {
    const enBloque = (f0: number, c0: number) => fila >= f0 && fila <= f0 + 6 && col >= c0 && col <= c0 + 6;
    return enBloque(0, 0) || enBloque(0, modulos - 7) || enBloque(modulos - 7, 0);
  };
  const pintarOjo = (fila: number, col: number) => {
    const f = fila < 7 ? fila : fila - (modulos - 7);
    const c = col < 7 ? col : col - (modulos - 7);
    const borde = f === 0 || f === 6 || c === 0 || c === 6;
    const centro = f >= 2 && f <= 4 && c >= 2 && c <= 4;
    return borde || centro;
  };
  const paso = tamano / modulos;
  return <svg width={tamano} height={tamano} viewBox={`0 0 ${tamano} ${tamano}`} role="img" aria-label={`Código QR del expediente ${valor}`} className="rounded bg-white" data-id="element-905" data-mp="w5vhtiaucb59">
      <rect width={tamano} height={tamano} fill="#ffffff" data-id="element-906" data-mp="4hlaycw0wdy3" />
      {Array.from({
      length: modulos
    }).map((_, fila) => Array.from({
      length: modulos
    }).map((__, col) => {
      const activo = esOjo(fila, col) ? pintarOjo(fila, col) : celdas[fila * modulos + col];
      if (!activo) return null;
      return <rect key={`${fila}-${col}`} x={col * paso} y={fila * paso} width={paso} height={paso} fill="#08182F" data-id="element-907" data-mp="1ouswlbfufpt9" data-mpi={col} />;
    }))}
    </svg>;
}